import * as actions from './actions';

export const reducer = (state, action) => {
    const { type, payload } = action;

    switch (type) {
        case actions.FETCH_INIT: {
            return {
                ...state,
                isLoading: true,
                error: null
            };
        }

        case actions.FETCH_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                error: null,
                data: payload
            };
        }

        case actions.FETCH_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: payload
            };
        }

        default:
            throw new Error(`Unknown action type ${type}`);
    }
};
